import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CustomerGateway {
  constructor(private _urlFactory: UrlFactory) {}

  linkUserUrl(id: string) {
    return this._urlFactory.createUrl(
      'customer',
      Location.joinWithSlash('v1/links', id),
    );
  }

  userAgreementUrl() {
    return this._urlFactory.createUrl('customer', 'v1/agreement');
  }
}
